export class TorresCredentials {
  apiKey: string;
}
